export default __webpack_public_path__ + "e8e7975d49818c65d5bd4def38e09662.png";